'use client';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { LuArrowLeft, LuArrowRight } from 'react-icons/lu';

interface ReservationFormFooterProps {
  step: number;
  totalSteps: number;
  isSubmitting?: boolean;
  onNext: () => void;
  onBack: () => void;
}

export function ReservationFormFooter({
  step,
  totalSteps,
  isSubmitting,
  onNext,
  onBack,
}: ReservationFormFooterProps) {
  const { t } = useTranslations();
  const isDesktop = useBreakpoint('sm');
  const isLastStep = step === totalSteps;

  return (
    <div className="flex w-full items-center justify-between gap-3">
      {step > 1 ? (
        <Button
          type="button"
          variant="outline"
          size={isDesktop ? 'default' : 'icon'}
          className="whitespace-nowrap"
          onClick={onBack}
          disabled={isSubmitting}
        >
          <LuArrowLeft size={20} />
          <p className="hidden sm:block">{t('text1026')}</p>
        </Button>
      ) : (
        <div />
      )}
      <Button
        type={isLastStep ? 'submit' : 'button'}
        className="w-full whitespace-nowrap sm:w-fit"
        onClick={isLastStep ? undefined : onNext}
        isLoading={isLastStep ? isSubmitting : undefined}
        disabled={isLastStep ? isSubmitting : false}
      >
        {isLastStep ? 'Odoslať' : t('text1027')}
        {!isLastStep && <LuArrowRight size={20} />}
      </Button>
    </div>
  );
}
